<template>
  <div>
    <div class="row py-3 border-bottom" v-for="(followup, index) in followups" :key="index">
      <!--Incall note-->
      <div class="col-12" v-if="followup.type_id === 1">
        <div class="row">
          <div class="col-2 pr-2">
            <div class="mod-icon-follow-up mod-icon-follow-incall" />
          </div>
          <div class="col-10 pl-0 followup-date"><p>{{ followup.date }}</p></div>
          <div class="col-12 followup-notes">
            <read-more class="show-more" more-str="Show more" :text="followup.notes" less-str="Show less" :max-chars="250" />
          </div>
        </div>
      </div>

      <!--Email note-->
      <div class="col-12 pointer" v-if="followup.type_id === 2" @click="showPreview(followup.id)">
        <div class="row">
          <div class="col-2 pr-2">
            <div class="mod-icon-follow-up mod-icon-follow-email" />
          </div>
          <div class="col-10 pl-0 followup-date"><p>{{ followup.date }}</p></div>
          <div class="col-12 followup-notes">
            <read-more class="show-more" more-str="Show more" :text="followup.notes" less-str="Show less" :max-chars="250" />
          </div>
        </div>
      </div>

      <!--Mesagge note-->
      <div class="col-12" v-if="followup.type_id === 4">
        <div class="row">
          <div class="col-2 pr-2">
            <div v-if="followup.type_id === 4" class="mod-icon-follow-up mod-icon-follow-message" />
          </div>
          <div class="col-10 pl-0 followup-date"><p>{{ followup.date }}</p></div>
          <div class="col-12 followup-notes">
            <read-more class="show-more" more-str="Show more" :text="followup.notes" less-str="Show less" :max-chars="250" />
            <p v-for="media in followup.media" :key="media.id" class="w-25 text-media pointer" @click="openFile(media.url)">
              <img :src="media.url" class="img img-fluid" alt="" />
            </p>
          </div>
        </div>
      </div>

      <!--Voice call note-->
      <div class="col-12" v-if="followup.type_id === 3">
        <div class="row">
          <div class="col-2 pr-2">
            <div class="mod-icon-follow-up mod-icon-follow-voice-call" />
          </div>
          <div class="col-10 pl-0 followup-date"><p>{{ followup.date }}</p></div>
          <div class="col-12 followup-notes">
            <read-more class="show-more" more-str="Show more" :text="followup.notes" less-str="Show less" :max-chars="250" />
          </div>
        </div>
      </div>
    </div>

    <div class="row py-2 px-2 mx-0 fixed-bottom border-top position-absolute follows-buttons" v-if="$_can('leads.follow-ups.store')">
      <div class="col pt-2 btn btn-secondary tooltip-parent" @click="showCallModal = true">
        <span
          class="mod-icon-btn-follow mod-icon-btn-incall"
        /><span class="tooltip-title">Leave in-call notes</span>
      </div>
      <div class="col pt-2 btn btn-secondary tooltip-parent" @click="showEmailModal = true">
        <span
          class="mod-icon-btn-follow mod-icon-btn-email"
        /><span class="tooltip-title">Send follow up email</span>
      </div>
      <div class="col pt-2 btn btn-secondary tooltip-parent"
           :class="lead.company.phone_numbers && !lead.company.phone_numbers.find(num => num.type.id === 1) && 'disabled'"
           @click="lead.company.phone_numbers && lead.company.phone_numbers.find(num => num.type.id === 1) ? showSMSModal = true : ''"
      >
        <span class="mod-icon-btn-follow mod-icon-btn-message" />
        <span class="tooltip-title tooltip-title-no-sms"
              v-if="lead.company.phone_numbers && !lead.company.phone_numbers.find(num => num.type.id === 1)"
        >Company doesn't have a <br />phone number for sending SMS</span>
        <span class="tooltip-title"
              v-if="lead.company.phone_numbers && lead.company.phone_numbers.find(num => num.type.id === 1)"
        >Send follow up SMS</span>
      </div>
      <div class="col pt-2 btn btn-secondary tooltip-parent" @click="showVoiceModal = true">
        <span
          class="mod-icon-btn-follow mod-icon-btn-voice-call"
        /><span class="tooltip-title tooltip-title-voice">Leave voice <br />message notes</span>
      </div>
    </div>


    <!--Call-->
    <template v-if="showCallModal">
      <call :lead="lead" @close="closeModal" />
    </template>

    <!--Email-->
    <template v-if="showEmailModal">
      <email :lead="lead" @close="closeModal" />
    </template>

    <!--SMS-->
    <template v-if="showSMSModal">
      <s-m-s :lead="lead" @close="closeModal" />
    </template>

    <!--Voice-->
    <template v-if="showVoiceModal">
      <voice :lead="lead" @close="closeModal" />
    </template>

    <!--Preview Email-->
    <template v-if="showPreviewEmail">
      <preview-email :lead="lead" :follow-up-id="followUpId" @close="closeModal" />
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Call from './followUps/Call';
import Email from './followUps/Email';
import SMS from './followUps/SMS';
import Voice from './followUps/Voice';
import PreviewEmail from './followUps/PreviewEmail';

export default {
  components: {
    PreviewEmail,
    Call,
    Email,
    SMS,
    Voice,
  },
  props: {
    lead: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    showCallModal: false,
    showEmailModal: false,
    showSMSModal: false,
    showVoiceModal: false,
    showPreviewEmail: false,
    followUpId: null,
  }),
  computed: {
    ...mapState({
      followups: state => state.followUps.followups,
    }),
  },
  watch: {
    followups() {
      const interval = setInterval(() => {
        const el = document.querySelector('.follows-wrap');
        if (el) {
          el.scrollTop = el.scrollHeight;
          clearInterval(interval);
        }
      }, 500);
    },
  },
  mounted() {
    this.getFollowUps(this.$route.params.id);
  },
  methods: {
    ...mapActions(['getFollowUps']),
    closeModal() {
      this.showCallModal = false;
      this.showEmailModal = false;
      this.showSMSModal = false;
      this.showVoiceModal = false;
      this.showPreviewEmail = false;
      this.getFollowUps(this.$route.params.id);
      this.message = {};
      this.$nextTick(() => {
        const el = document.querySelector('.follows-wrap');
        el.scrollTop = el.scrollHeight;
      });
      this.$emit('update');
    },
    openFile(url) {
      window.open(url, '_blank');
    },
    showPreview(id) {
      this.followUpId = id;
      this.showPreviewEmail = true;
    },
  },
};
</script>
<style scoped>
.tooltip-parent .tooltip-title {
  z-index: 20;
}
.text-media {
  height: 15vh;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/leads/LeadsFollowups.vue